import React, {useCallback, useMemo, useState} from 'react'
import {Headers, Sort, SortKeys, SortOrder} from '../../types'
import {useQuery} from 'react-query'
import {Get, Post} from '../../../../../../setup'
import {useMailing} from '../../../../../../app/@types'
import {List} from '../../../../../../app/pages/mailing/contacts/types'
import {THead} from '../../components/THead'
import {paginate} from '../../../../content/pagination/types'
import {Pagination} from '../../../../content/pagination/Pagination'
import {Link} from 'react-router-dom'
import {PATH_MAILING} from '../../../../../../app/routing/paths'
import {ActionsButton} from '../../components/ActionsButtons'
import {SelectAll} from '../../../../../../app/@components'
import {CreateContactListMailing} from '../../../../modals/CreateContactList.mailing'
import {Search} from '../../../../content/forms'
import {FormatDateToCA, SearchedData} from '../../../../../../app/features'

const headers: Headers<List>[] = [
  {key: 'created_at', label: 'Date', className: 'fw-bolder text-muted bg-light min-w-150px'},
  {key: 'name', label: 'Titre', className: 'fw-bolder text-muted bg-light min-w-200px'},
  {key: 'subscribers_count', label: 'Contacts', className: 'fw-bolder text-muted bg-light min-w-200px'},
]

const LISTS_CONTACTS = process.env.REACT_APP_MAILING_LISTS_CONTACTS || 'v2/list-contact'
const REMOVE_CONTACTS = process.env.REACT_APP_MAILING_REMOVE_CONTACTS_LISTS || 'v2/list-contact-delete'

type handleRemoveType = {ids: number[]}

const TablesWidget22 = () => {

  const {reloadKey, triggerReload} = useMailing()
  const [sortKey, setSortKey] = useState<SortKeys<List>>('created_at')
  const [sortOrder, setSortOrder] = useState<SortOrder>('desc')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [selectedItems, setSelectedItems] = useState<number[]>([])
  const [selectAll, setSelectAll] = useState<boolean>(false)
  const [searchQuery, setSearchQuery] = useState<string>('')
  const [data, setData] = useState<List[]>([])

  useQuery(
    [`CONTACTS_LISTS`, reloadKey],
    () => Get<List[]>({endpoint: LISTS_CONTACTS}), {
      onSuccess: (data) => setData(data)
    }
  )

  const dataSorted: List[] = useMemo(() => {
    return Sort<List>({data: data ? data : [], sortKey, reverse: sortOrder === 'desc'})
  }, [data, sortKey, sortOrder])

  const filteredData = useMemo(() => {
    return SearchedData<List>(dataSorted, searchQuery)
  }, [dataSorted, searchQuery])

  const paginateData = useMemo(
    () => paginate<List>({currentPage, itemsPerPage, data: filteredData}),
    [currentPage, itemsPerPage, filteredData],
  )

  const handleCheckboxChange = (id: number) => {

    let updatedSelectedItems
    if (selectedItems.includes(id)) {
      updatedSelectedItems = selectedItems.filter(itemId => itemId !== id)
    } else {
      updatedSelectedItems = [...selectedItems, id]
    }
    setSelectedItems(updatedSelectedItems)
    setSelectAll(updatedSelectedItems.length === paginateData.length)
  }

  const handleRemove = useCallback(async ({ids}: handleRemoveType) => {

    const data = {tags: {ids}}
    try {
      await Post<any>(REMOVE_CONTACTS, data)
      triggerReload()
      setSelectedItems([])
    } catch (e) {
      console.log(e)
    }

  }, [triggerReload])

  return (
    <>
      <div className="row mb-10">
        <div className="col-12 col-sm-8 mb-3 mb-sm-0 text-gray-400 fw-bold">
          Organisez vos contacts des différentes listes pour mieux gérer et envoyer vos campagnes et scénarios d'e-mails
          automatisés.
        </div>
        <div
          className="col-12 col-sm-4 d-flex justify-content-end align-items-center align-items-sm-start align-items-md-center">
          <CreateContactListMailing />
        </div>
      </div>
      <div className="row d-flex justify-content-between align-items-center mb-5">
        <div className="col-1 d-flex align-items-center">

          <SelectAll selectAll={selectAll}
                     setSelectAll={setSelectAll}
                     setSelectedItems={setSelectedItems}
                     data={paginateData}
          />

          <ActionsButton tooltip="Supprimer"
                         iconPath="/media/icons/duotune/general/gen027.svg"
                         iconClass="svg-icon-2 svg-icon-danger"
                         className="btn btn-sm btn-icon btn-active-light-danger"
                         onClick={() => handleRemove({ids: selectedItems})}
                         disabled={!selectedItems.length}
          />
        </div>
        <div className="col-7 col-md-5">
          <Search setSearchInput={setSearchQuery} />
        </div>
      </div>


      <div className="table-responsive">
        <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
          <THead
            headers={headers}
            sortKey={sortKey}
            setSortKey={setSortKey}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            firstChildren={<th className="min-w-50px" />}
            children={<th className="fw-bolder text-muted text-center bg-light min-w-100px">
              <span className="btn btn-sm text-muted w-auto px-0">
                Actions
              </span>
            </th>}
          />
          <tbody>
          {
            paginateData.map((item, index) => (
              <tr key={index}>
                <td>
                <div className="form-check form-check-sm form-check-custom form-check-solid">
                    <input
                      className="form-check-input me-3"
                      type="checkbox"
                      value={item.id}
                      checked={selectedItems.includes(item.id)}
                      onChange={() => handleCheckboxChange(item.id)}
                    />
                  </div>
                </td>
                <td>
                  <span className="text-dark fw-bolder fs-6">{FormatDateToCA(item.created_at)}</span>
                </td>
                <td>
                  <span className="">
                    <Link className="text-dark text-hover-primary fw-bolder fs-6"
                          to={`${PATH_MAILING.contacts.show}/${item.id}`}>
                      {item.name}
                    </Link>
                    </span>
                </td>
                <td>
                  <span className="text-dark fw-bolder fs-6">{item.subscribers_count}</span>
                </td>
                <td className="text-center">
                  <ActionsButton tooltip="Aperçu"
                                 to={`${PATH_MAILING.contacts.show}/${item.id}`}
                                 iconPath=""
                                 iconClass="bi bi-eye-fill fs-3 text-success"
                                 className="btn btn-sm btn-icon btn-active-light-success me-1"
                  />
                  <ActionsButton tooltip="Supprimer"
                                 iconPath="/media/icons/duotune/general/gen027.svg"
                                 iconClass="svg-icon-2 svg-icon-danger"
                                 className="btn btn-sm btn-icon btn-active-light-danger"
                                 onClick={() => handleRemove({ids: [item.id]})}
                  />
                </td>
              </tr>
            ))
          }
          </tbody>
        </table>
      </div>

      <Pagination itemsPerPage={itemsPerPage}
                  totalItems={filteredData.length}
                  setCurrentPage={setCurrentPage}
                  setItemsPerPage={setItemsPerPage}
      />
    </>
  )
}

export {TablesWidget22}